import * as THREE from "three";

// Вершинный шейдер
const vertexShader = `
  varying vec2 vUv;
  
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

// Фрагментный шейдер для овальной тени, вписанной в прямоугольник
const fragmentShader = `
  uniform float opacity;
  uniform float softness;
  uniform vec2 aspect; // width/height для прямоугольной формы
  varying vec2 vUv;
  
  void main() {
    // Центр в UV координатах
    vec2 center = vec2(0.5, 0.5);
    
    // Вычисляем расстояние от центра с учетом aspect ratio для эллипса
    // offset в UV координатах (от -0.5 до 0.5)
    vec2 offset = vUv - center;
    
    // Для эллипса, вписанного в прямоугольник:
    // Эллипс должен быть пропорционален прямоугольнику width x height
    // В UV координатах прямоугольник всегда 1x1
    // Используем уравнение эллипса: (x/a)^2 + (y/b)^2 = 1
    // где a и b - полуоси эллипса
    
    // Полуоси эллипса в масштабированных координатах
    // Для эллипса, вписанного в прямоугольник, нужно учесть aspect ratio
    // Эллипс делаем в 1.5 раза меньше прямоугольника
    // Если aspect.x > 1 (широкий), то эллипс шире по X
    float a = 0.5 * aspect.x / 1.5; // полуось по X (масштабированная, уменьшена в 1.5 раза)
    float b = 0.5 / 1.5; // полуось по Y (уменьшена в 1.5 раза)
    
    // Вычисляем эллиптическое расстояние от центра
    // offset уже в диапазоне [-0.5, 0.5] в UV координатах
    float dist = sqrt((offset.x * offset.x) / (a * a) + (offset.y * offset.y) / (b * b));
    
    // Максимальное расстояние для эллипса (на краю эллипса dist = 1.0)
    float maxDist = 1.0;
    
    // Нормализуем расстояние (0.0 в центре, 1.0 на краю эллипса)
    float normalizedDist = dist / maxDist;
    
    // Градиент от центра (темнее) к краям (светлее)
    // Используем обратную функцию - чем дальше от центра, тем светлее
    float fadeStart = 0.0;
    float fadeEnd = 1.0 * softness;
    
    // Градиент: центр темный, края светлые
    float alpha = opacity * (1.0 - smoothstep(fadeStart, fadeEnd, normalizedDist));
    
    // Дополнительное сглаживание для более плавного перехода
    alpha = smoothstep(0.0, 1.0, alpha);
    
    // Убираем все, что вне эллипса (за пределами normalizedDist > 1.0)
    if (normalizedDist > 1.0) {
      alpha = 0.0;
    }
    
    gl_FragColor = vec4(0.0, 0.0, 0.0, alpha);
  }
`;

class RectShadowMaterial extends THREE.ShaderMaterial {
  constructor(opacity = 0.4, softness = 1.5, aspect = [1, 1]) {
    super({
      vertexShader,
      fragmentShader,
      uniforms: {
        opacity: { value: opacity },
        softness: { value: softness },
        aspect: { value: new THREE.Vector2(aspect[0], aspect[1]) },
      },
      transparent: true,
      depthWrite: false,
    });
  }
}

export { RectShadowMaterial };

